import React from "react";
import glamorous from "glamorous";
import { VictoryPie } from "victory";

import Colors from "../../styles/colors";
import { colorForExceptionType } from "./ExceptionLink";

export const ExceptionDonutChart = props => {
  const {
    shipmentsTotals,
    site,
    part,
    pushSearchView,
    clearSearchFilters,
    setSearch,
    setSearchCategory,
    searchShipments,
    locations
  } = props;

  let data = [];
  let chartLabel = "Total";

  if (shipmentsTotals.total_shipments === null) {
    chartLabel = "Loading...";
  } else if (shipmentsTotals.total_shipments === 0) {
    data = [{ x: 1, y: 1, fill: Colors.background.GRAY }];
  } else {
    data = shipmentsTotals.details.map(e => {
      return {
        x: e.key,
        y: e.count,
        fill: colorForExceptionType(e.key)
      };
    });

    // Add in shipments without exceptions
    data.push({
      y: shipmentsTotals.total_on_time,
      fill: Colors.highlight.GREEN
    });

    // Remove data with 0 exceptions
    data = data.filter(d => d.y > 0);
  }

  const handleClick = () => {
    // FIXME, do not support searching on both PART NUMBER and SITE

    const selected_location = locations
      ? locations.filter(l => l.id === site)
      : [];

    // If both Site and Part are null, then we will display all
    // shipments
    if (site === null && part === null) {
      clearSearchFilters();
      setSearchCategory("everything");
      setSearch("", "");
      searchShipments({label: "", value: ""}, "everything", {});
      pushSearchView();
    } else if (selected_location.length === 1) {
      clearSearchFilters();
      setSearchCategory("location");
      setSearch(selected_location[0].name, selected_location[0].id);
      searchShipments({label: selected_location[0].name, value: selected_location[0].id}, "location", {});
      pushSearchView();
    } else if (part && part.length > 0) {
      clearSearchFilters();
      setSearchCategory("part_number");
      setSearch(part, part);
      searchShipments({label: part, value: part}, "part_number", {});
      pushSearchView();
    }
  };

  return (
    <glamorous.Div
      css={{
        minHeight: "10em",
        minWidth: "10em",
        maxWidth: "10em",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ":hover": {
          cursor: "pointer"
        }
      }}
      onClick={() => handleClick()}
    >
      <glamorous.Div
        css={{
          position: "absolute",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: Colors.background.GRAY_BLUE,
          fontSize: "xx-large"
        }}
      >
        {shipmentsTotals.total_shipments}
        <glamorous.Div
          css={{
            fontStyle: "italic",
            fontSize: "small",
            color: Colors.background.DARK_BLUE,
            marginLeft: "-4px"
          }}
        >
          {chartLabel}
        </glamorous.Div>
      </glamorous.Div>
      <VictoryPie
        data={data}
        innerRadius={135}
        padAngle={2}
        labels={() => null}
        style={{
          data: {
            fill: d => d.fill
          }
        }}
      />
    </glamorous.Div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/exceptions/ExceptionDonutChart.js